import {
  CognitoIdentityProviderClient, ListUsersCommand, AdminCreateUserCommand, AdminDisableUserCommand,
  AdminDeleteUserCommand, AdminEnableUserCommand, ListGroupsCommand, AdminAddUserToGroupCommand,
  CreateGroupCommand
} from "@aws-sdk/client-cognito-identity-provider";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";
import { format } from "date-fns";
import axios from 'axios'
import { generatePublicID } from '../common/methods'

const reg = 'ap-southeast-2'
const options = {
  // Required. The unique identifier for the identity against which credentials
  // will be issued.
  identityPoolId: process.env.VUE_APP_COGNITO_IDENTITY_ID,
  // Optional. The ARN of the role to be assumed when multiple roles were received in the token
  // from the identity provider.
  clientConfig: { region: reg },
}
const config = {
  region: reg,
  credentials: fromCognitoIdentityPool(options),
}

//client can be shared
const client = new CognitoIdentityProviderClient(config)

const terminalAxios = axios.create({
  baseURL: process.env.VUE_APP_ENDPOINT_API_TERMINAL
});

// Add a request interceptor to put auth header
terminalAxios.interceptors.request.use(async config => {
  // get token from local storage, if expired, updateAuthToken will refresh the token
  await window.tbmCPApp.$store.dispatch('account/updateAuthToken')
  const token = window.localStorage.getItem('auth_token')

  config.headers.Authorization = token

  return config
}, err => Promise.reject(err))


const terminalRegions = process.env.VUE_APP_TERMINAL_REGIONS.split(",")

const store = {
  namespaced: true,
  state: {
    users: [],
    groups: [],
    terminalVenues: [],
    registeredTerminals: [],
    enrolledTerminals: [],
  },
  mutations: {
    users(state, users) {
      state.users = users
    },
    groups(state, groups) {
      state.groups = groups
    },
    setTerminalVenues(state, { venues }) {
      state.terminalVenues = venues
    },
    setRegisteredTerminals(state, { terminals }) {
      state.registeredTerminals = terminals
    },
    setEnrolledTerminals(state, { terminals }) {
      state.enrolledTerminals = terminals
    },
  },
  actions: {
    async fetchCognitoUsers(context) {

      const params = {
        UserPoolId: process.env.VUE_APP_OC_TERMINAL_COGNITO_POOL_ID
      }
      const command = new ListUsersCommand(params)
      try {
        const data = await client.send(command);
        let users = []
        data.Users.forEach(
          (user) => {
            user.UserCreateDate = format(
              new Date(user.UserCreateDate),
              "yyyy-MM-dd HH:mm:ss"
            )
            user.UserLastModifiedDate = format(
              new Date(user.UserLastModifiedDate),
              "yyyy-MM-dd HH:mm:ss"
            )
            let attributesObj = user.Attributes.reduce((obj, cur) => { return { ...obj, [cur.Name]: cur.Value } }, {})
            delete user.Attributes
            users.push({ ...attributesObj, ...user }) //merge custom attributes into user object

          }

        )
        context.commit('users', [...users])
        // process data.
      } catch (error) {
        console.log(error)
        // error handling.
      } finally {
        // finally.
      }

    },

    //create an user in oc terminal user pool
    async createUser(context, userObj) {
      const params = {
        UserPoolId: process.env.VUE_APP_OC_TERMINAL_COGNITO_POOL_ID,
        Username: userObj.username,
        email_verified: true,
        DesiredDeliveryMediums: [
          'EMAIL'
        ],
        UserAttributes: [
          { Name: "email", Value: userObj.email },
          { Name: "email_verified", Value: "True" },
          { Name: "custom:venue", Value: userObj.venue },
          { Name: "custom:admin", Value: userObj.admin.toString() }
        ],
        ForceAliasCreation: false,
        MessageAction: "SUPPRESS",
      }

      const command = new AdminCreateUserCommand(params)
      try {
        await client.send(command);
        await context.dispatch('EnsureGroupExisting', userObj.venue)
        await context.dispatch('AddUserToGroup', { userName: userObj.username, groupName: userObj.venue })
        await context.dispatch('ResendConfirmationEmail', userObj.username)
        await context.dispatch('audit/auditUIEvent', { action: "Create Terminal User", details: JSON.stringify(userObj) }, { root: true })
      }
      catch (e) {
        alert(e)
      }

    },

    //check if a group exist in cognito or not, if not existing, then create one
    async EnsureGroupExisting(context, groupName) {
      context.dispatch('fetchGroups')
      if (context.getters.getGroups.findIndex(g => g.GroupName == groupName) < 0) {
        const params = {
          UserPoolId: process.env.VUE_APP_OC_TERMINAL_COGNITO_POOL_ID,
          GroupName: groupName
        }

        const command = new CreateGroupCommand(params)
        try {
          await client.send(command);
        }
        catch (e) {
          alert(e)
        }
      }

    },

    //add an user into a group
    async AddUserToGroup(context, { userName, groupName }) {
      const params = {
        UserPoolId: process.env.VUE_APP_OC_TERMINAL_COGNITO_POOL_ID,
        Username: userName,
        GroupName: groupName
      }


      const command = new AdminAddUserToGroupCommand(params)
      try {
        await client.send(command);
      }
      catch (e) {
        alert(e)
      }
    },

    //resend the confirmation email for an existing user
    async ResendConfirmationEmail(context, userName) {
      const params = {
        UserPoolId: process.env.VUE_APP_OC_TERMINAL_COGNITO_POOL_ID,
        Username: userName,
        MessageAction: "RESEND",
      }

      const command = new AdminCreateUserCommand(params)
      try {
        await client.send(command);
      }
      catch (e) {
        alert(e)
      }
    },

    //get all the user groups
    async fetchGroups(context) {
      const params = {
        UserPoolId: process.env.VUE_APP_OC_TERMINAL_COGNITO_POOL_ID,
      }


      const client = new CognitoIdentityProviderClient(config)
      const command = new ListGroupsCommand(params)
      try {
        const data = await client.send(command);
        context.commit('groups', data.Groups)
      }
      catch (e) {
        alert(e)
      }
    },

    //disable the user from the user pool
    async DisableUser(context, userName) {
      const params = {
        UserPoolId: process.env.VUE_APP_OC_TERMINAL_COGNITO_POOL_ID,
        Username: userName,
      }

      const command = new AdminDisableUserCommand(params)
      try {
        await client.send(command);
        await context.dispatch('audit/auditUIEvent', { action: "Disable Terminal User", description: `User Name: ${userName}` }, { root: true })
      }
      catch (e) {
        alert(e)
      }
    },

    //enable a disabled user
    async EnableUser(context, userName) {
      const params = {
        UserPoolId: process.env.VUE_APP_OC_TERMINAL_COGNITO_POOL_ID,
        Username: userName,
      }

      const command = new AdminEnableUserCommand(params)
      try {
        await client.send(command);
        await context.dispatch('audit/auditUIEvent', { action: "Enable Terminal User", description: `User Name: ${userName}` }, { root: true })
      }
      catch (e) {
        console.log(e)
      }
    },

    //delete a disabled user from the pool
    async DeleteUser(context, userName) {
      const params = {
        UserPoolId: process.env.VUE_APP_OC_TERMINAL_COGNITO_POOL_ID,
        Username: userName,
      }

      const command = new AdminDeleteUserCommand(params)
      try {
        await client.send(command);
        await context.dispatch('audit/auditUIEvent', { action: "Delete Terminal User", description: `User Name: ${userName}` }, { root: true })
      }
      catch (e) {
        alert(e)
      }
    },
    async fetchTerminalVenues(context) {
      var finalVenueList = []
      for (let region of terminalRegions) {
        var regionVenues = []
        try {
          let res = await terminalAxios.post('api.public.Public/GetListVenues',
            {
              region: region
            })
          regionVenues = res.data.venues
        } catch (error) {
          //set default venues, will be removed once betdirector has the api to list all venues
          regionVenues = [
            { venueCode: 'CAN' },
            { venueCode: 'MN2' },
            { venueCode: 'UKT2' },
            { venueCode: 'MN' },
            { venueCode: 'PLY' },
            { venueCode: 'SUF' },
            { venueCode: 'NGT' },
            { venueCode: 'LIB' },
            { venueCode: 'UKT' },
            { venueCode: 'NGW' },
            { venueCode: 'BN' },
            { venueCode: 'LVDC' },
            { venueCode: 'CAY' }]
        }
        regionVenues.forEach(v => {
          v.region = region
        })
        finalVenueList = finalVenueList.concat(regionVenues)
      }

      context.commit('setTerminalVenues', { venues: finalVenueList })
    },
    async fetchRegisteredTerminals(context) {
      var finalTerminalList = []
      for (let region of terminalRegions) {
        var regionTerminalList = []
        try {
          const res = await terminalAxios.post('api.public.Public/GetStatusOctTerminal',
            { region: region })
          for (let i = 0; i < res.data.statuses.length; i++) {
            res.data.statuses[i].region = region
            res.data.statuses[i].publicId = await generatePublicID(res.data.statuses[i].terminalId)
          }
          regionTerminalList = res.data.statuses

        } catch (error) {
          //
        }
        finalTerminalList = finalTerminalList.concat(regionTerminalList)
      }
      context.commit('setRegisteredTerminals', { terminals: finalTerminalList })
    },
    async fetchEnrolledTerminals(context) {
      var finalTerminalList = []
      for (let region of terminalRegions) {
        var regionTerminalList = []
        try {
          const res = await terminalAxios.post('api.public.Public/GetListEnrolledTerminals',
            {
              region: region
            },
            {

            })
          for (let i = 0; i < res.data.terminals.length; i++) {
            res.data.terminals[i].region = region
            res.data.terminals[i].publicId = await generatePublicID(res.data.terminals[i].terminalId)
          }
          regionTerminalList = res.data.terminals

        } catch (error) {
          //
        }
        finalTerminalList = finalTerminalList.concat(regionTerminalList)
      }
      context.commit('setEnrolledTerminals', { terminals: finalTerminalList })
    },
    async registerTerminal(context, { terminalId, location, venue, username, password, branch }) {
      try {
        const region = context.state.enrolledTerminals.find(t=>t.terminalId == terminalId).region
        await terminalAxios.post('api.public.Public/RegisterTerminal',
          {
            terminal_id: terminalId,
            ba_username: username,
            ba_password: password,
            location: location,
            venue_code: venue,
            branch: branch,
            region: region
          },
          {

          })
      } catch (error) {
        //
      }
    },
    async deregisterTerminal(context, terminalId) {
      try {
        const region = context.state.registeredTerminals.find(t=>t.terminalId == terminalId).region
        await terminalAxios.post('api.public.Public/DeregisterTerminal',
          {
            terminal_id: terminalId,
            region: region
          },
          {

          })
        context.dispatch('fetchRegisteredTerminals')
      } catch (error) {
        //
      }
    },
  },
  getters: {
    getUsers: (state) => {
      return state.users
    },
    getGroups: (state) => {
      return state.groups
    },
    getTerminalVenues(state) {
      return state.terminalVenues
    },
    getRegisteredTerminals(state) {
      return state.registeredTerminals
    },
    getEnrolledTerminals(state) {
      return state.enrolledTerminals
    },
  },

}

export default store